#n8n-chat main {
  padding-top: 0;
}

.chat-message {
  max-width: 80%;
}

.chat-message.chat-message-typing {
  max-width: 80px;
}

.chat-message-markdown a {
  display: inline;
}

.chat-window-wrapper .chat-window {
  box-shadow: rgba(0, 0, 0, 0.2) 0 0 0.428571rem 0;
  border-radius: 0.571429rem;
  border: 0;
}

.chat-window-wrapper .chat-window-toggle {
  display: none !important;
}

.chat-layout .chat-header {
  align-items: center;
}

.chat-layout .chat-header h1 {
  margin: 0;
  height: 18px;
  font-weight: 400;
}

.chat-footer .chat-inputs-controls button[disabled] {
  border: unset !important;
  cursor: no-drop !important;
  color: var(--chat--color-disabled) !important;
}

.chat-message-markdown h3 {
  font-size: 1.11rem;
  margin: 0 0 10px;
  line-height: normal;
}

.chat-message-typing .chat-message-typing-circle {
  height: 5px;
  width: 5px;
  border-radius: 100%;
  margin: 3px;
}

:root {
  --chat--font-family:
    -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;
  --chat--color-secondary: #00a2ab;
  --chat--color-secondary-shade-50: #00828a;
  --chat--color-white: #ffffff;
  --chat--color-light: #f2f4f8;
  --chat--color-light-shade-50: #e6e9f1;
  --chat--color-light-shade-100: #c2c5cc;
  --chat--color-medium: #d2d4d9;
  --chat--color-dark: #101330;
  --chat--color-disabled: #777980;
  --chat--color-typing: #404040;
  --chat--window--bottom: 75px;
  --chat--window--right: 20px;

  --chat--spacing: 1rem;
  --chat--border-radius: 0.6rem;
  --chat--transition-duration: 0.15s;

  --chat--window--width: 360px;
  --chat--window--height: 530px;

  --chat--header--padding: 10px;
  --chat--header--background: var(--chat--color-primary);
  --chat--header--color: var(--chat--color-light);
  --chat--header--border-top: none;
  --chat--header--border-bottom: none;
  --chat--header--border-bottom: none;
  --chat--header--border-bottom: none;
  --chat--heading--font-size: 1.07143rem;
  --chat--subtitle--font-size: inherit;
  --chat--subtitle--line-height: 1.8;

  --chat--textarea--height: 50px;

  --chat--message--font-size: 0.88rem;
  --chat--message--padding: 0.5rem;
  --chat--message--border-radius: var(--chat--border-radius);
  --chat--message-line-height: 1.3;
  --chat--message--bot--background: var(--chat--color-white);
  --chat--message--bot--color: var(--chat--color-dark);
  --chat--message--bot--border: none;
  --chat--message--user--background: #f56675;
  --chat--message--user--color: var(--chat--color-white);
  --chat--message--user--border: none;
  --chat--message--pre--background: rgba(0, 0, 0, 0.05);

  --chat--toggle--background: var(--chat--color-primary);
  --chat--toggle--hover--background: var(--chat--color-primary-shade-50);
  --chat--toggle--active--background: var(--chat--color-primary-shade-100);
  --chat--toggle--color: var(--chat--color-white);
  --chat--toggle--size: 45px;
  --font-weight-bold: 700;
  --chat--input--send--button--color: #00a2ab;
  --chat--window--z-index: 1000000;
}

@media (max-width: 767px) {
  :root {
    --chat--window--width: 100vw;
    --chat--window--height: 100vh;
  }
  .chat-window-wrapper {
    right: 0;
    bottom: 0;
    max-width: none;
    max-height: none;
  }

  .chat-window-toggle {
    position: fixed;
    top: 3px;
    right: 20px;
    left: none;
  }
  .chat-window {
    width: 100vw !important;
    height: 100vh !important;
    margin: 0 !important;
    border-radius: 0 !important;
  }
  .chat-window + .chat-window-toggle {
    display: inline-flex !important;
    top: -10px !important;
  }
  .chat-window[style='display: none;'] + .chat-window-toggle {
    display: none !important;
  }
}
